import React from "react";
import "../css/createTikTokDestination.css";
import { useSelector } from "react-redux";
import SwalAlertComp from "./SwalAlert";
import LoginButton from "./molecules/LoginButton";
import { tiktokReLogin } from "../helpers/destinations/createDestination";

const ReconnectTikTokDestination = ({ setAuthData, isLoading }) => {
    const language = useSelector((state) => state.languagesState.languages);

    const getAuthUrl = async () => {
        const response = await tiktokReLogin();
        if (response?.status) {
            return response?.data?.auth_url ?? null;
        }
        SwalAlertComp({
            title: language?.delete_swal_modal?.failed ?? "Failed",
            message: response?.message,
            icon: "error",
        });
        return null;
    };

    const handleSuccess = (data) => {
        if (setAuthData) {
            setAuthData(data);
        }
    };

    return (
        <LoginButton
            code="tiktok"
            getAuthUrl={getAuthUrl}
            paramNames={["auth_code", "state"]}
            onSuccess={handleSuccess}
            dataTransform={(params) => ({
                code: params.auth_code,
                state: params.state,
            })}
            logoSrc="/assets/images/typeImages/tiktok-icon.png"
            buttonText={
                language?.destination_modal?.reconnect_with_tiktok ??
                "Reconnect with Tiktok"
            }
            isLoadingExternal={isLoading}
        />
    );
};

export default ReconnectTikTokDestination;
